(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateGrievance', MigrateGrievance);

    MigrateGrievance.$inject = ['$resource'];

    function MigrateGrievance ($resource) {
        var resourceUrl =  '/api/migrategrievance';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
